const INITIAL_STATE = [];

const Cart = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ADD_PRODUCT': {
      const existingProduct = state.find((prod) => prod.id === action.product.id);
      if (existingProduct) {
        if (
          existingProduct.quantity + existingProduct.count_step >
          action.product.purchasable_count
        ) {
          return state;
        }
        return state.map((prod) =>
          prod.id === action.product.id
            ? { ...prod, quantity: prod.quantity + prod.count_step }
            : prod
        );
      }
      return [...state, { ...action.product, quantity: action.product.count_step }];
    }

    case 'REMOVE_PRODUCT':
      return action.product;

    case 'CLEAN_CART':
      return [];

    // case 'UPDATE_CART':
    //   return action.cart;
    case 'UPDATE_CART':
      if (!Array.isArray(state)) {
        return INITIAL_STATE;
      }
      if (!Array.isArray(action.cart)) {
        return state;
      }
      return state.map((prod) => {
        const updated = action.cart.find((c) => c.product_id === prod.id);

        if (!updated) return prod;

        return {
          ...prod,
          quantity: updated.quantity,
          price: updated.price,
          payable_amount: updated.payable_amount,
          discount_amount: updated.discount_amount,
          purchasable_count: updated.purchasable_count
        };
      });
    case 'DECREASE_PRODUCT':
      return state.map((prod) =>
        prod.id === action.product_id
          ? { ...prod, quantity: prod.quantity - prod.count_step }
          : prod
      );

    default:
      return state;
  }
};
export default Cart;
